import Swal from "sweetalert2";
import { URL } from "../../Helpers/Accesos";

export const LoginAction = (user, password) => {
  return new Promise((resolve, req) => {
    if (user === undefined || user === null || user === "") {
      return req("Favor de ingresar su usuario");
    }
    if (password === undefined || password === null || password === "") {
      return req("Favor de ingresar su contraseña");
    }
    try {
      fetch(`${URL}Authenticate`, {
        method: "POST",
        body: JSON.stringify({ user, password }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(async (result) => {
          const body = await result.json();
          if (result.ok) {
            return resolve(body);
          } else {
            return req(body);
          }
        })
        .catch(() => {
          return req("Error al consultar el servidor");
        });
    } catch (error) {
      return req(error);
    }
  });
};

export const AutenticacionAction = (usuario, codigoseguridad, token, oneSignalID = "") => {
  return new Promise((resolve, req) => {
    try {
      fetch(`${URL}CodigoSeguridad`, {
        method: "POST",
        body: JSON.stringify({ usuario, codigoseguridad, oneSignalID }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then(async (result) => {
          const body = await result.json();
          if (result.ok) {
            return resolve(body);
          } else {
            return req(body);
          }
        })
        .catch((error) => {
          return req("Error al consultar el servidor");
        });
    } catch (error) {
      return req(error);
    }
  });
};
const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});
export const ValidateUserAction = () => {
  return new Promise(async (resolve, req) => {
    try {
      var token = localStorage.getItem("HumayaDigital-Token");
      fetch(`${URL}ValidateUser`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then(async (result) => {
          const body = await result.json();
        
          if (result.status === 401) {
            swalWithBootstrapButtons
              .fire({
                icon: "warning",
                title: "SESION",
                text: "LA SESION A CADUCADO, FAVOR DE INICIAR SESION DE NUEVO",
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: "OK",
                reverseButtons: false,
              })
              .then(() => {
                return req(body);
              });
          }

          if (result.ok) {
            return resolve(body);
          } else {
            return req(body);
          }
        })
        .catch((error) => {
          return req(error);
        });
    } catch (error) {
      return req(error);
    }
  });
};
